var _style, _defs, _use, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _use2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _g2, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _g3, _g4, _path226, _path227, _g5, _path228, _path229, _g6, _g7, _path230, _path231, _g8, _path232, _path233, _path234, _path235, _g9, _g10, _path236, _g11, _path237, _g12, _path238, _g13, _g14, _path239, _path240, _path241, _path242, _path243, _g15, _path244, _path245, _g16, _g17, _g18, _path246, _path247, _path248, _g19;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 4280.372,
    height: 6114.817,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{fill:url(#Cb)}.C{fill:url(#Cc)}.D{fill:none}.E{opacity:.35}.F{fill:url(#U)}.G{fill:url(#W)}.H{fill:url(#y)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 0.5,
    x2: 0.5,
    y2: 0.574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "B",
    cx: 1.014,
    cy: 0.359,
    r: 0.815,
    gradientTransform: "translate(-0.214) scale(1.429 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h4280.37v2558.37H0z",
    className: "D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 0.5,
    y1: 0.061,
    x2: 0.5,
    y2: 0.897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 -1 2215.154 1466.775)",
    d: "M0 0h2215.154v1466.775H0z",
    className: "D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 119.254,
    y1: 0.005,
    x2: 119.254,
    y2: 1.091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a7a7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 119.85,
    x2: 119.85,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 120.695,
    x2: 120.695,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 122.021,
    x2: 122.021,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 123.766,
    x2: 123.766,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 125.511,
    x2: 125.511,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 127.086,
    x2: 127.086,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 128.624,
    x2: 128.624,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 130.16,
    x2: 130.16,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 131.686,
    x2: 131.686,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 133.403,
    x2: 133.403,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 135.067,
    x2: 135.067,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 136.815,
    x2: 136.815,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 138.372,
    x2: 138.372,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 140.215,
    x2: 140.215,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 141.884,
    x2: 141.884,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 143.151,
    x2: 143.151,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 144.248,
    x2: 144.248,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 143.652,
    x2: 143.652,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 142.5,
    x2: 142.5,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 141.153,
    x2: 141.153,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 139.463,
    x2: 139.463,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 137.642,
    x2: 137.642,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 135.97,
    x2: 135.97,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 134.251,
    x2: 134.251,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 132.542,
    x2: 132.542,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 130.831,
    x2: 130.831,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 129.308,
    x2: 129.308,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 127.836,
    x2: 127.836,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 126.194,
    x2: 126.194,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 124.553,
    x2: 124.553,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 122.846,
    x2: 122.846,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 121.327,
    x2: 121.327,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 119.696,
    x2: 119.696,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 122.096,
    x2: 122.096,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 123.762,
    x2: 123.762,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 125.341,
    x2: 125.341,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 127.011,
    x2: 127.011,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 128.512,
    x2: 128.512,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 130.031,
    x2: 130.031,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 134.972,
    x2: 134.972,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 138.642,
    x2: 138.642,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 140.464,
    x2: 140.464,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 143.401,
    x2: 143.401,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 144.857,
    x2: 144.857,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 142.652,
    x2: 142.652,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 137.766,
    x2: 137.766,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AA",
    x1: 132.403,
    x2: 132.403,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AB",
    x1: 130.684,
    x2: 130.684,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AC",
    x1: 129.158,
    x2: 129.158,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AD",
    x1: 127.622,
    x2: 127.622,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AE",
    x1: 126.011,
    x2: 126.011,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AF",
    x1: 124.437,
    x2: 124.437,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AG",
    x1: 123.625,
    x2: 123.625,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AH",
    x1: 125.087,
    x2: 125.087,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AI",
    x1: 126.857,
    x2: 126.857,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AJ",
    x1: 128.309,
    x2: 128.309,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AK",
    x1: 129.941,
    x2: 129.941,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AL",
    x1: 131.541,
    x2: 131.541,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AM",
    x1: 133.251,
    x2: 133.251,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AN",
    x1: 135.154,
    x2: 135.154,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AO",
    x1: 136.97,
    x2: 136.97,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AP",
    x1: 140.292,
    x2: 140.292,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AQ",
    x1: 144.151,
    x2: 144.151,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AR",
    x1: 143.247,
    x2: 143.247,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AS",
    x1: 141.056,
    x2: 141.056,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AT",
    x1: 139.215,
    x2: 139.215,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AU",
    x1: 137.815,
    x2: 137.815,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AV",
    x1: 135.817,
    x2: 135.817,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AW",
    x1: 134.153,
    x2: 134.153,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AX",
    x1: 132.139,
    x2: 132.139,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AY",
    x1: 130.541,
    x2: 130.541,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AZ",
    x1: 128.942,
    x2: 128.942,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aa",
    x1: 127.512,
    x2: 127.512,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ab",
    x1: 125.797,
    x2: 125.797,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ac",
    x1: 124.193,
    x2: 124.193,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ad",
    x1: 126.624,
    x2: 126.624,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ae",
    x1: 129.684,
    x2: 129.684,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Af",
    x1: 131.205,
    x2: 131.205,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ag",
    x1: 133.069,
    x2: 133.069,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ah",
    x1: 136.764,
    x2: 136.764,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ai",
    x1: 138.515,
    x2: 138.515,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aj",
    x1: 140.057,
    x2: 140.057,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ak",
    x1: 141.808,
    x2: 141.808,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Al",
    x1: 140.806,
    x2: 140.806,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Am",
    x1: 137.604,
    x2: 137.604,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "An",
    x1: 135.765,
    x2: 135.765,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ao",
    x1: 133.972,
    x2: 133.972,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ap",
    x1: 131.941,
    x2: 131.941,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aq",
    x1: 130.309,
    x2: 130.309,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ar",
    x1: 127.385,
    x2: 127.385,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "As",
    x1: 129.542,
    x2: 129.542,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "At",
    x1: 131.03,
    x2: 131.03,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Au",
    x1: 132.757,
    x2: 132.757,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Av",
    x1: 134.817,
    x2: 134.817,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aw",
    x1: 136.604,
    x2: 136.604,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ax",
    x1: 138.461,
    x2: 138.461,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ay",
    x1: 141.729,
    x2: 141.729,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Az",
    x1: 143.498,
    x2: 143.498,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BA",
    x1: 144.401,
    x2: 144.401,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BB",
    x1: 142.577,
    x2: 142.577,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BC",
    x1: 139.167,
    x2: 139.167,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BD",
    x1: 135.606,
    x2: 135.606,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BE",
    x1: 133.757,
    x2: 133.757,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BF",
    x1: 131.758,
    x2: 131.758,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BG",
    x1: 130.205,
    x2: 130.205,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BH",
    x1: 130.939,
    x2: 130.939,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BI",
    x1: 132.614,
    x2: 132.614,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BJ",
    x1: 134.606,
    x2: 134.606,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BK",
    x1: 136.37,
    x2: 136.37,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BL",
    x1: 139.983,
    x2: 139.983,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BM",
    x1: 141.65,
    x2: 141.65,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BN",
    x1: 140.731,
    x2: 140.731,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BO",
    x1: 139.629,
    x2: 139.629,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BP",
    x1: 134.473,
    x2: 134.473,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BQ",
    x1: 131.833,
    x2: 131.833,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BR",
    x1: 128.436,
    x2: 128.436,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BS",
    x1: 10.004,
    y1: 0.287,
    x2: 10.072,
    y2: 0.819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "BT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2919.984v2275.632H0z",
    className: "D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BU",
    x1: 0.5,
    x2: 0.5,
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BV",
    x1: 0.464,
    y1: 0.272,
    x2: 0.543,
    y2: 0.8,
    xlinkHref: "#BS"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "BW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2884.184v2652.26H0z",
    className: "D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BX",
    x1: 11.189,
    y1: 0.005,
    x2: 11.189,
    y2: 1.091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f4142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e6e6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BY",
    x1: 12.763,
    x2: 12.763,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BZ",
    x1: 14.299,
    x2: 14.299,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ba",
    x1: 15.835,
    x2: 15.835,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bb",
    x1: 17.362,
    x2: 17.362,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bc",
    x1: 19.081,
    x2: 19.081,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bd",
    x1: 20.745,
    x2: 20.745,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Be",
    x1: 22.492,
    x2: 22.492,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bf",
    x1: 24.048,
    x2: 24.048,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bg",
    x1: 25.891,
    x2: 25.891,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bh",
    x1: 26.829,
    x2: 26.829,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bi",
    x1: 25.139,
    x2: 25.139,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bj",
    x1: 23.318,
    x2: 23.318,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bk",
    x1: 21.648,
    x2: 21.648,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bl",
    x1: 19.927,
    x2: 19.927,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bm",
    x1: 18.218,
    x2: 18.218,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bn",
    x1: 16.509,
    x2: 16.509,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bo",
    x1: 14.985,
    x2: 14.985,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bp",
    x1: 13.512,
    x2: 13.512,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bq",
    x1: 14.19,
    x2: 14.19,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Br",
    x1: 15.706,
    x2: 15.706,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bs",
    x1: 20.647,
    x2: 20.647,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bt",
    x1: 24.318,
    x2: 24.318,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bu",
    x1: 26.139,
    x2: 26.139,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bv",
    x1: 23.442,
    x2: 23.442,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bw",
    x1: 18.081,
    x2: 18.081,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bx",
    x1: 16.362,
    x2: 16.362,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "By",
    x1: 14.835,
    x2: 14.835,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bz",
    x1: 17.218,
    x2: 17.218,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CA",
    x1: 18.927,
    x2: 18.927,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CB",
    x1: 20.83,
    x2: 20.83,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CC",
    x1: 22.647,
    x2: 22.647,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CD",
    x1: 25.969,
    x2: 25.969,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CE",
    x1: 26.734,
    x2: 26.734,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CF",
    x1: 24.891,
    x2: 24.891,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CG",
    x1: 23.492,
    x2: 23.492,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CH",
    x1: 21.492,
    x2: 21.492,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CI",
    x1: 19.83,
    x2: 19.83,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CJ",
    x1: 17.817,
    x2: 17.817,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CK",
    x1: 18.745,
    x2: 18.745,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CL",
    x1: 22.442,
    x2: 22.442,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CM",
    x1: 24.191,
    x2: 24.191,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CN",
    x1: 25.734,
    x2: 25.734,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CO",
    x1: 26.484,
    x2: 26.484,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CP",
    x1: 23.282,
    x2: 23.282,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CQ",
    x1: 21.442,
    x2: 21.442,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CR",
    x1: 19.647,
    x2: 19.647,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CS",
    x1: 20.492,
    x2: 20.492,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CT",
    x1: 22.282,
    x2: 22.282,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CU",
    x1: 24.139,
    x2: 24.139,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CV",
    x1: 24.844,
    x2: 24.844,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CW",
    x1: 22.048,
    x2: 22.048,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CX",
    x1: 25.66,
    x2: 25.66,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CY",
    x1: 26.407,
    x2: 26.407,
    xlinkHref: "#BX"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CZ",
    x1: 0.341,
    y1: 0.147,
    x2: 0.484,
    y2: 0.678
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13171a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h4280.37v3184.043H0z",
    className: "D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cb",
    x1: 7.876,
    y1: 0.005,
    x2: 7.876,
    y2: 1.091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cc",
    xlinkHref: "#Cb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cd",
    x1: 0.5,
    y1: 0.265,
    x2: 0.5,
    y2: 0.706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3426.018v2393.647H0z",
    className: "D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cf",
    x1: 3.038,
    y1: 0.005,
    x2: 3.038,
    y2: 1.091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565656"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Cg",
    cx: 1.202,
    cy: 0.254,
    r: 1.093,
    gradientTransform: "translate(-0.214) scale(1.429 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e68c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#d37717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269,
    stopColor: "#b7583b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#006d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00538f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ch",
    d: "M.002 0h4280.37v6114.816H.002z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ci",
    d: "M1985.143 770.712l80.18 275.97h-160.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cj",
    d: "M595.43 1031.342l-105.69 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ck",
    d: "M1798.58 355.362l-105.69 428.154h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cl",
    d: "M2694.914 145.014l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cm",
    d: "M2944.523 103.055l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cn",
    d: "M2881.605 204.065l-105.693 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Co",
    d: "M1210.028 804.2l-105.69 428.153h211.383z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ch",
    fill: "url(#A)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ch",
    fill: "url(#B)",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)",
    transform: "translate(.002 1042.681)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2247.855 1168.274l411.96 513.99c9.254 6.47 238.367 190.65 238.367 190.65l275.45 513.99H4790.41l-154.6-203.572-629.463-301.38-437.93-408.31 38.764 157.84 10.117 143.71-87.128-252.2-133.593-106.586c-16.46-15.1-101.02-76.17-101.02-76.17l-32.746 109.455-27.116 10.052-28.626-39.994 61.22-52.937-51.794-3.818-62.6-60.832-250.9-350.405-58.654 147.292 52.14 136.3h-94.333l128.46 295.08-274.738-245.745-317.794-151.843z",
    fill: "#ababab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3530.17 1522.993l87.12 252.2-10.117-143.702-38.76-157.84z",
    fill: "#8f8f8f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3207.064 1419.762l28.64 40 27.1-10.06 32.755-109.457-27.264 26.583z",
    fill: "#a1a1a1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2157.495 463.634l64.823 19.393-60.207 77.615 95.024 87.17 63.787 17.732 205.967 237.59-150.57-246.694c1.553-2.395 48.71 30.18 48.71 30.18l-48.71-96.06 175.788 151.865-238.216-285.74-193.628-274.24z",
    fill: "#e3e3e3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2095.066 472.5l-43.9 138.426c4.962-9.1 110.943-50.284 110.943-50.284l60.207-77.615-64.822-19.393-37.232-281.187L1858.057 484.7l-40.986 142.265 117.134-54.6-123.67 208.838z",
    fill: "#969696"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M371.314 1839.154l382.787-6.946 331.514-165.757 323.446-72.567 351.058-410.768 118.86-168.13 168.906-258.666 118.86-69.7 90.385-38.808-95.024-87.17s-105.982 41.18-110.943 50.284c-4.81 9.1 43.9-138.426 43.9-138.426l-284.528 308.714L1934.2 572.377l-117.134 54.6 40.986-142.265-97.763 112.8-117.307 103-54.528-45.75-283.668 376.984-348.815 369.566H860.6l-65.513-61.07-90.04 144.66z",
    fill: "#777"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-466.898 2386.9h3640.53l-275.45-513.99-238.367-190.65c-9.276-6.472-411.955-513.99-411.955-513.99l90.213-35.442-120.393-297.47-49.4 136.506-144.725-34-69.81 145.375-193.628 99.877-351.054 410.768-323.446 72.567-331.514 165.757-382.8 6.946-159.135 134.608-203.4 167.655-222.965 17.948z",
    fill: "#6d6d6d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2340.466 809.493l-122.786 25.865 120.392 297.474 317.794 151.843 274.74 245.745-128.46-295.08h94.333l-52.14-136.288 58.654-147.29-57.273 38.074-185.56-114.246-76.32-95.325-31.733-37.837-175.787-151.865 48.71 96.06s-47.156-32.57-48.71-30.18c0 4.55 141.834 232.565 150.57 246.694l-205.967-237.59-63.787-17.732-90.386 38.808z",
    fill: "#b7b7b7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1760.122 1183.124l193.623-99.872 69.8-145.385 144.746 34.012 49.393-136.527 122.792-25.867-173.727-122.87-118.852 69.7-168.926 258.67z",
    fill: "#737373"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a1a1a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2902.996 951.755l-57.282 38.083v35.992l-24.8 48.465 23.427 24.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2820.916 1074.295l13.137 161.044h-31.9l-19.55 76.222-34.918 55.24 182.925 163.616-128.457-295.08h94.327l-52.137-136.284z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4635.804 2183.33l-629.458-301.375-437.927-408.31-38.247 49.356-133.593-106.586c-16.46-15.1-101.02-76.17-101.02-76.17l-27.267 26.577-51.794-3.818-62.6-60.832-250.906-350.418-57.273 38.074-185.56-114.244-76.32-95.325-31.732-37.837L2313.9 456.688l-193.606-274.24-359.99 415.063-117.307 103-54.534-45.754-283.667 376.99-348.814 369.566h-95.37l-65.513-61.07-90.04 144.66-333.737 354.253-159.135 134.606-203.4 167.655-222.965 17.948-252.712 227.54h5257.306z",
    fill: "url(#D)",
    style: {
      mixBlendMode: "screen"
    },
    className: "E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)",
    transform: "translate(0 2165.51)"
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ci",
    fill: "url(#F)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1937.418 770.712l80.18 275.97h-160.356z",
    fill: "url(#G)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1869.678 706.616l80.18 275.97H1789.5z",
    fill: "url(#H)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1763.45 664.758l80.178 275.97H1683.27z",
    fill: "url(#I)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1623.582 592.814l80.18 275.97h-160.358z",
    fill: "url(#J)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1483.485 526.77l80.18 275.97h-160.36z",
    fill: "url(#K)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.243 478.374l80.18 275.97h-160.36z",
    fill: "url(#L)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.08 425.006l80.18 275.97H1153.9z",
    fill: "url(#M)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.92 346.777l80.18 275.97h-160.357z",
    fill: "url(#N)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M988.54 277.45l80.18 275.97H908.363z",
    fill: "url(#O)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M850.72 229.05l80.18 275.97H770.54z",
    fill: "url(#P)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M717.273 234.996l80.18 275.97h-160.36z",
    fill: "url(#Q)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M577.175 186.55l80.18 275.968h-160.36z",
    fill: "url(#R)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M452.47 150.935l80.18 275.97H372.293z",
    fill: "url(#S)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M304.677 103.848l80.178 275.97H224.497z",
    fill: "url(#T)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M170.742 93.468l80.18 275.97H90.564z",
    className: "F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.133 78.983l80.18 275.97h-160.36z",
    fill: "url(#V)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.614 66.424l80.178 275.97H-98.794z",
    className: "G"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.118 131.53l80.177 275.97H-51.062z",
    fill: "url(#X)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 150.935l80.177 275.97H41.3z",
    fill: "url(#Y)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M229.49 164.017l80.18 275.97H149.313z",
    fill: "url(#Z)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M364.97 189.454l80.18 275.97H284.8z",
    fill: "url(#a)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M510.973 216.968l80.18 275.97H430.795z",
    fill: "url(#b)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M644.914 264.057l80.18 275.97h-160.36z",
    fill: "url(#c)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M782.86 317.69l80.178 275.97H702.68z",
    fill: "url(#d)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M919.872 324.536l80.183 275.97H839.698z",
    fill: "url(#e)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.947 392.772l80.18 275.97h-160.36z",
    fill: "url(#f)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.1 445.094l80.178 275.968H1098.92z",
    fill: "url(#g)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.206 518.345l80.178 275.97h-160.36z",
    fill: "url(#h)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.833 569.36l80.18 275.97h-160.36z",
    fill: "url(#i)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1560.35 616.36l80.18 275.97h-160.364z",
    fill: "url(#j)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1697.366 685.146l80.178 275.97h-160.358z",
    fill: "url(#k)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1818.983 741.06l80.18 275.97h-160.36z",
    fill: "url(#l)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1949.86 844.602l80.177 275.97H1869.68z",
    fill: "url(#m)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1869.678 836.752l80.18 275.97H1789.5z",
    fill: "url(#H)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1757.292 836.752l80.18 275.97h-160.36z",
    fill: "url(#n)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1623.908 802.747l80.177 275.966h-160.358z",
    fill: "url(#o)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1497.283 741.06l80.18 275.97h-160.357z",
    fill: "url(#p)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.345 664.758l80.178 275.97h-160.357z",
    fill: "url(#q)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.89 611.127l80.18 275.97h-160.36z",
    fill: "url(#r)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.26 537.084l80.18 275.97H1041.08z",
    fill: "url(#s)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M988.54 445.094l80.18 275.97H908.363z",
    fill: "url(#O)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M850.72 399.098l80.18 275.97H770.54z",
    fill: "url(#P)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M725.095 385.38l80.177 275.97H644.918z",
    fill: "url(#t)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M577.175 346.777l80.18 275.97h-160.36z",
    fill: "url(#R)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M430.795 317.69l80.178 275.97H350.615z",
    fill: "url(#u)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M284.792 256.007l80.178 275.97H204.612z",
    fill: "url(#v)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M170.742 241.025l80.18 275.97H90.564z",
    className: "F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M49.12 242.926l80.18 275.97H-31.06z",
    fill: "url(#w)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M-67.526 247.396l80.177 275.97h-160.357z",
    fill: "url(#x)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M109.295 321.04l80.18 275.97H29.118z",
    className: "H"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M229.49 362.897l80.18 275.97H149.313z",
    fill: "url(#Z)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M364.97 385.38l80.18 275.97H284.8z",
    fill: "url(#a)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M501.03 380.91l80.18 275.97H420.853z",
    fill: "url(#z)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M644.914 425.006l80.18 275.97h-160.36z",
    fill: "url(#c)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M782.86 459.025l80.178 275.97H702.68z",
    fill: "url(#d)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M930.9 530.755l80.183 275.97H850.72z",
    fill: "url(#AA)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.72 569.36l80.18 275.97H988.54z",
    fill: "url(#AB)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.102 626.915l80.18 275.97h-160.36z",
    fill: "url(#AC)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.26 718.903l80.18 275.97h-160.36z",
    fill: "url(#AD)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1443.522 749.113l80.18 275.97h-160.358z",
    fill: "url(#AE)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1569.766 787.055l80.178 275.97h-160.357z",
    fill: "url(#AF)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1697.366 841.103l80.178 275.97h-160.358z",
    fill: "url(#k)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1634.747 919.585l80.18 275.97h-160.36z",
    fill: "url(#AG)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1517.6 887.098l80.18 275.97h-160.358z",
    fill: "url(#AH)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1375.723 836.752l80.18 275.97h-160.358z",
    fill: "url(#AI)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.28 781.602l80.178 275.97H1179.1z",
    fill: "url(#AJ)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.42 707.344l80.177 275.97H1048.24z",
    fill: "url(#AK)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.055 616.36l80.178 275.97H919.876z",
    fill: "url(#AL)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M863.037 563l80.18 275.97H782.86z",
    fill: "url(#AM)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M710.458 537.084l80.18 275.97H630.276z",
    fill: "url(#AN)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M564.734 480.78l80.18 275.97h-160.36z",
    fill: "url(#AO)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M430.795 480.78l80.178 275.97H350.615z",
    fill: "url(#u)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M298.4 431.374l80.18 275.97H218.215z",
    fill: "url(#AP)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M170.742 402.043l80.18 275.97H90.564z",
    className: "F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.047 340.392l80.18 275.97h-160.36z",
    fill: "url(#AQ)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M61.564 402.043l80.18 275.97H-18.614z",
    fill: "url(#AR)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M109.295 500.88l80.18 275.97H29.118z",
    className: "H"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M237.077 518.345l80.18 275.97h-160.36z",
    fill: "url(#AS)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M384.853 547.16l80.18 275.97H304.677z",
    fill: "url(#AT)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M496.993 563l80.18 275.97H416.815z",
    fill: "url(#AU)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M657.355 603.076l80.178 275.97H577.175z",
    fill: "url(#AV)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M790.633 638.868l80.18 275.97h-160.36z",
    fill: "url(#AW)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M952.06 685.146l80.18 275.97H871.88z",
    fill: "url(#AX)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.235 734.994l80.18 275.97h-160.36z",
    fill: "url(#AY)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.598 799.334l80.18 275.97H1128.42z",
    fill: "url(#AZ)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.072 887.098l80.18 275.97h-160.364z",
    fill: "url(#Aa)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1460.694 908.45l80.18 275.97H1380.52z",
    fill: "url(#Ab)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1589.2 974.738l80.18 275.97H1509z",
    fill: "url(#Ac)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.434 1004.824l80.178 275.97H1314.26z",
    fill: "url(#Ad)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.28 969.505l80.178 275.972H1179.1z",
    fill: "url(#AJ)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.9 914.837l80.177 275.97H1068.72z",
    fill: "url(#Ae)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.07 823.13l80.178 275.97H946.9z",
    fill: "url(#Af)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M877.632 734.994l80.178 275.97H797.452z",
    fill: "url(#Ag)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M725.095 689l80.177 275.97H644.918z",
    fill: "url(#t)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M581.21 643.616l80.18 275.97H501.03z",
    fill: "url(#Ah)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M440.99 661.35l80.18 275.97H360.817z",
    fill: "url(#Ai)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M317.258 603.076l80.18 275.97h-160.36z",
    fill: "url(#Aj)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M176.96 583.077l80.18 275.97H96.783z",
    fill: "url(#Ak)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M29.118 553.418l80.177 275.97H-51.062z",
    fill: "url(#X)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.614 656.33L61.564 932.3H-98.794z",
    className: "G"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M109.295 672.908l80.18 275.972H29.118z",
    className: "H"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M257.14 711.142l80.18 275.97H176.958z",
    fill: "url(#Al)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M384.853 718.903l80.18 275.97H304.677z",
    fill: "url(#AT)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M513.856 741.06l80.18 275.97H433.672z",
    fill: "url(#Am)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M661.39 787.055l80.177 275.97H581.21z",
    fill: "url(#An)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M805.27 812.65l80.18 275.97H725.094z",
    fill: "url(#Ao)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M968.093 867.82l80.18 275.97H887.915z",
    fill: "url(#Ap)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.918 925.04l80.18 275.97h-160.354z",
    fill: "url(#Aq)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.598 992.712l80.18 275.97H1128.42z",
    fill: "url(#AZ)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.25 1046.434l80.18 275.97h-160.36z",
    fill: "url(#Ar)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.415 1075.303l80.178 275.968h-160.358z",
    fill: "url(#As)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.08 1024.9l80.176 275.964H960.9z",
    fill: "url(#At)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M902.664 886.912l80.18 275.97H822.486z",
    fill: "url(#Au)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M737.533 856.89l80.18 275.97H657.355z",
    fill: "url(#Av)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M594.035 812.65l80.18 275.97h-160.36z",
    fill: "url(#Aw)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M445.15 823.53l80.18 275.97H364.97z",
    fill: "url(#Ax)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M317.258 764.9l80.18 275.97h-160.36z",
    fill: "url(#Aj)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M183.12 754.346l80.18 275.97H102.94z",
    fill: "url(#Ay)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 741.06l80.18 275.97H-38.868z",
    fill: "url(#Az)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M-31.06 845.33l80.177 275.97H-111.24z",
    fill: "url(#BA)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M115.192 874.678l80.183 275.968H35.015z",
    fill: "url(#BB)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M257.14 902.884l80.18 275.97H176.958z",
    fill: "url(#Al)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M388.577 919.585l80.18 275.97H308.4z",
    fill: "url(#BC)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M513.856 941.79l80.18 275.97H433.672z",
    fill: "url(#Am)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M674.215 983.313l80.183 275.97H594.036z",
    fill: "url(#BD)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M822.486 1012.662l80.178 275.972H742.306z",
    fill: "url(#BE)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M982.784 1065.856l80.18 275.97H902.606z",
    fill: "url(#BF)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.248 1130.7l80.18 275.97H1027.07z",
    fill: "url(#BG)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1048.273 1184.417l80.18 275.97h-160.36z",
    fill: "url(#BH)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M913.987 1024.9l80.18 275.97h-160.36z",
    fill: "url(#BI)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M754.393 1004.824l80.18 275.97H674.215z",
    fill: "url(#BJ)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M612.83 961.512l80.18 275.97H532.65z",
    fill: "url(#BK)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M564.734 1024.9l80.18 275.97h-160.36z",
    fill: "url(#AO)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M452.47 1012.662l80.18 275.972H372.293z",
    fill: "url(#S)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M323.15 925.04l80.18 275.97H242.97z",
    fill: "url(#BL)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M189.475 914.837l80.18 275.97h-160.36z",
    fill: "url(#BM)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 886.912l80.18 275.97H-38.868z",
    fill: "url(#Az)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.614 992.712l80.178 275.97H-98.794z",
    className: "G"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M115.192 1012.662l80.183 275.972H35.015z",
    fill: "url(#BB)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M49.12 1052.82l80.18 275.97H-31.06z",
    fill: "url(#w)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M189.475 1063.024l80.18 275.97h-160.36z",
    fill: "url(#BM)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M263.3 1035.554l80.178 275.97H183.12z",
    fill: "url(#BN)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M351.666 1063.024l80.177 275.97H271.486z",
    fill: "url(#BO)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M657.355 1130.7l80.178 275.97H577.175z",
    fill: "url(#AV)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M765.12 1150.786l80.18 275.97H684.943z",
    fill: "url(#BP)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M877.632 1130.7l80.178 275.97H797.452z",
    fill: "url(#Ag)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M976.766 1190.806l80.18 275.97H896.59z",
    fill: "url(#BQ)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.97 1112.723l80.18 275.97h-160.36z",
    fill: "url(#BR)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-56.33 932.3h-42.463l80.18-275.97 3.147 10.84 14.764-50.8h-90.524l27.02-93h-83.5l52.58-180.968h-3.667l80.18-275.97 33.322 114.7 14.4-49.59 12.374 42.593 27.642-95.14 36.63 126.075 15.724-54.126 16.28 56.03 32.974-113.5 39.623 136.38 19.125-65.83 28.852 99.31 46.334-159.475 42.583 146.567 17.7-60.96 38.157 131.325 49.346-169.845 38.844 133.7 19.66-67.664 28.68 98.72 37.52-129.137 45.128 155.33 22.61-77.824 31.956 109.994 40.4-139.056 44.8 154.214 20.78-71.52 21.054 72.466 46.81-161.106 48.45 166.76 20.707-71.273 27.493 94.624 41.178-141.713L1039.5 452.83l17.45-60.06 20.306 69.892 33.67-115.887 48.373 166.49 19.807-68.173 24.57 84.57 30.408-104.657 45.12 155.3 18-61.965 24.212 83.34 35.826-123.3 49.01 168.7 22.577-77.7 21.14 72.764 33.514-115.35 51.444 177.07 25.416-87.485 28.2 97.053 35.04-120.6 50.306 173.147 23.48-80.812 30.08 103.533 36-123.92 38.852 133.72 16.682-57.42 20.344 70.022 30.35-104.465 43.18 148.625 24.56-84.53 23.862 82.132 23.865-82.134 80.18 275.97h-56.755l21.468 73.89H1869.68l2.28-7.85h-95.677l1.262 4.35h-85.42l22.8 78.484h-61.583l16.024 55.15H1509.01l19.26-66.3h-81.653l28 96.376h-73.275l12.09 41.6h-103.54l19.26 66.287h-146.946l5.222 17.978h-74.586l15.607 53.718h-73.363l1.857 6.39H896.6l17.462-60.107h-74.588l5.837 20.088h-160.36l5.835-20.088h-113.6l30.74-105.805H484.555l3.555-12.23h-70.9l14.632 50.36H271.485l7.98-27.47h-17.792l7.982 27.47h-160.36l2.966-10.2h-143.32l17.462-60.105h-85.197L-55.97 1121.3h-55.27z",
    fill: "url(#BS)",
    style: {
      mixBlendMode: "screen"
    },
    className: "E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BT)",
    transform: "translate(1360.388 1994.436)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#BU)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.194 1195.725l-105.7 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.106 1195.725l-105.7 428.153H471.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.4 1096.283l-105.7 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.796 919.725L674.11 1347.878H885.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.475 817.266l-105.7 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.886 742.18l-105.69 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.24 659.376l-105.692 428.153h211.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.58 538.007L1349.9 966.16h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.903 430.45l-105.7 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ck"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1974.487 364.586L1868.8 792.74h211.376z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2159.162 289.426L2053.47 717.58h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2323.543 234.172l-105.69 428.154h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2518.367 161.113l-105.692 428.154h211.38z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2828.856 122.54l-105.692 428.154h211.383z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cm"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2759.84 234.172l-105.695 428.154h211.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2617.472 254.465l-105.692 428.15h211.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2438.886 293.93l-105.693 428.154h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2246.426 336.616L2140.734 764.77h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.868 409.675l-105.7 428.155h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.03 492.877l-105.69 428.155h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.417 503.502l-105.69 428.153h211.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.732 609.365l-105.69 428.155h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.71 690.543l-105.7 428.154h211.383z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Co"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.514 883.334L930.828 1311.5h211.386z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.157 956.255l-105.69 428.153h211.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.544 1062.972l-105.7 428.153h211.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.227 1149.72l-105.692 428.15h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.71 1310.363l-105.693 428.15H455.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.4 1298.184l-105.7 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.546 1298.184l-105.69 428.153H709.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.373 1245.42l-105.69 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.283 1149.72l-105.7 428.15h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.842 1031.342l-105.69 428.153h211.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.625 948.138l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.955 833.26l-105.69 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.903 690.543l-105.7 428.154h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.58 619.184l-105.69 428.154h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964.177 597.9l-105.693 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2159.162 538.007L2053.47 966.16h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2352.116 492.877l-105.69 428.155H2457.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2544.578 397.183l-105.69 428.153h211.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2694.914 373.942l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2855.238 376.888l-105.69 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3009 383.824l-105.7 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775.913 498.08l-105.69 428.157h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2617.472 563.02L2511.78 991.173h211.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2438.886 597.9l-105.693 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2259.53 590.966l-105.69 428.15h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.868 659.376l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.03 712.156l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.887 823.442l-105.692 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511.212 883.334L1405.52 1311.5h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.9 972.63l-105.7 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.546 1115.347l-105.69 428.153h211.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.15 1162.213l-105.7 428.154h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.74 1221.08l-105.692 428.153H956.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.544 1304.932l-105.7 428.153h211.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.08 1426.695l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.502 1376.3l-105.69 428.154h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.525 1298.184l-105.693 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.02 1212.62l-105.69 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.516 1097.41l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1601.725 956.255l-105.693 428.153h211.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.34 873.455l-105.7 428.155h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1983.47 833.26l-105.688 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175.56 745.907l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2352.116 745.907l-105.69 428.153H2457.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2526.645 669.26l-105.69 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2694.914 623.75l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2934.546 528.102l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2838.832 623.75l-105.7 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775.913 777.098l-105.69 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2607.475 804.2l-105.694 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2412.674 848.897l-105.692 428.15h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2264.852 873.455l-105.7 428.155h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2053.47 935.645L1947.78 1363.8h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.78 991.17l-105.688 428.155h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664.995 1062.972l-105.693 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.032 1140.31l-105.7 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.827 1240.13l-105.69 428.158h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.934 1376.3l-105.7 428.154h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.516 1409.416l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.137 1512.26l-105.692 428.153H930.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.855 1558.936L976.164 1987.1h211.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.02 1504.142l-105.69 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.52 1419.326l-105.7 428.15h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.117 1277.048L1460.424 1705.2h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.103 1140.31l-105.686 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964.177 1068.95l-105.693 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2153.84 998.542L2048.15 1426.7h211.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2338.67 1026.052l-105.694 428.154h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2501.78 935.645L2396.1 1363.8h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2686.713 904.62l-105.688 428.153h211.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2881.605 858.602l-105.693 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2944.523 1018.266l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2775.913 1043.987l-105.69 428.15h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2581.022 1103.305l-105.688 428.153h211.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2412.674 1115.347L2306.982 1543.5h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2242.627 1149.72l-105.69 428.15h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2048.147 1221.08l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.484 1260.79l-105.7 428.154h211.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.856 1346.382l-105.692 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.4 1435.156L1365.71 1863.31h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.827 1540.152l-105.69 428.15h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.512 1623.492l-105.693 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.342 1668.283l-105.69 428.154h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.648 1590.075l-105.692 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.105 1376l-105.69 428.153h211.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1947.778 1329.424l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2136.937 1260.79l-105.69 428.154h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2333.193 1277.668l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2501.78 1186.706L2396.1 1614.86h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2678.597 1170.333l-105.7 428.153H2784.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2865.532 1149.72l-105.692 428.15h211.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2960.928 1311.49l-105.7 428.15h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2768.136 1357.023l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2581.022 1400.783l-105.688 428.153h211.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2407.767 1426.695l-105.7 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2242.627 1461.14l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2031.246 1525.564l-105.693 428.154h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835.796 1571.098l-105.69 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.492 1653.627l-105.7 428.153h211.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.425 1754.227l-105.69 428.154h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.165 1837.57l-105.69 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.18 1590.075l-105.69 428.153h211.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.553 1558.936l-105.7 428.154h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2112.16 1491.742l-105.693 428.154h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175.56 1590.075l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2323.543 1571.098l-105.69 428.153h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2494.013 1435.156L2388.32 1863.31h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670.222 1419.326l-105.69 428.15h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2865.532 1376l-105.692 428.153h211.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2944.523 1540.152l-105.69 428.15h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2768.136 1571.098l-105.69 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2855.238 1633.403l-105.69 428.154h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670.222 1649.233l-105.69 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2572.908 1606.617l-105.69 428.153h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2456.424 1649.233l-105.69 428.153h211.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2053.47 1754.227L1947.78 2182.38h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1911.413 1785.394l-105.693 428.153h211.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.103 1754.227l-105.686 428.154h211.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632.423 1847.482l-105.692 428.15h211.383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.613 1726.338l-105.7 428.153H1379.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2994.24 1446.418h55.976l-105.693-428.153-4.15 16.82-19.46-78.83h119.326l-35.617-144.278h110.07l-69.307-280.768h4.834l-105.696-428.153-43.926 177.947-18.992-76.938-16.312 66.078-36.437-147.6-48.287 195.602-20.728-83.972-21.456 86.928-43.47-176.086-52.23 211.584-25.21-102.133-38.033 154.067-61.076-247.42-56.132 227.394-23.348-94.577-50.3 203.747-65.048-263.5-51.2 207.42-25.912-104.98-37.81 153.16-49.455-200.35-59.488 240.986-29.806-120.737-42.125 170.65-53.257-215.738-59.06 239.258-27.39-110.965-27.755 112.43-61.7-249.947-63.866 258.718-27.3-110.58-36.24 146.806-54.273-219.86-67.168 272.1-23-93.183-26.767 108.436-44.38-179.793-63.76 258.3-26.1-105.768-32.388 131.206-40.082-162.373-59.485 240.95-23.73-96.134-31.917 129.3-47.226-191.3-64.6 261.72-29.767-120.563-27.866 112.888-44.177-178.958-67.812 274.71-33.506-135.722-37.172 150.575L779.8 919.724l-66.31 268.622-30.95-125.375-39.657 160.63-47.458-192.258-51.213 207.462-22-89.083-26.818 108.635-40.01-162.073-56.912 230.585-32.38-131.144-31.456 127.426-31.456-127.426-105.7 428.154h74.813l-28.3 114.634H455.4l-3-12.175h126.114l-1.665 6.748h112.6l-30.06 121.764h81.176l-21.12 85.564h211.383l-25.388-102.846h107.635l-36.91 149.523h96.594l-15.937 64.556h136.484l-25.388 102.845h193.7l-6.884 27.9h98.313l-20.573 83.34h96.706l-2.446 9.912h211.38l-23.02-93.252h98.32l-7.692 31.164h211.38l-7.693-31.164h149.75l-40.523-164.157h162.612l-4.683-18.976h93.453l-19.287 78.135h211.383l-10.52-42.62h23.453l-10.518 42.62h211.38l-3.907-15.83h188.926l-23.02-93.252h112.306l-56.447-228.662h72.852z",
    fill: "url(#BV)",
    style: {
      mixBlendMode: "screen"
    },
    className: "E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BW)",
    transform: "translate(.002 2412.577)"
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M2708.37 1228.647l175.81 712.21h-351.627z",
    fill: "url(#BX)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M2431.552 1103.737l175.81 712.218H2255.74z",
    fill: "url(#BY)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M2161.488 966.006L2337.3 1678.22h-351.625z",
    fill: "url(#BZ)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.436 764.114l175.813 712.21h-351.625z",
    fill: "url(#Ba)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1623.088 585.195l175.812 712.212h-351.626z",
    fill: "url(#Bb)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.878 460.3l175.812 712.212h-351.623z",
    fill: "url(#Bc)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.263 475.635l175.814 712.213H852.452z",
    fill: "url(#Bd)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M721.065 350.6l175.812 712.21H545.253z",
    fill: "url(#Be)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M447.624 258.697l175.814 712.21H271.812z",
    fill: "url(#Bf)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M123.548 137.17l175.81 712.2H-52.266z",
    fill: "url(#Bg)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M-41.315 292.454L134.5 1004.666h-351.625z",
    fill: "url(#Bh)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M255.757 358.1l175.813 712.212H79.945z",
    fill: "url(#Bi)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M575.907 429.11l175.81 712.21H400.093z",
    fill: "url(#Bj)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M869.6 550.638l175.81 712.21H693.79z",
    fill: "url(#Bk)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.08 689.046l175.8 712.212H996.264z",
    fill: "url(#Bl)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1472.523 706.717l175.812 712.2H1296.7z",
    fill: "url(#Bm)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1773.082 882.816l175.812 712.212H1597.27z",
    fill: "url(#Bn)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M2040.934 1017.848l175.814 712.21h-351.626z",
    fill: "url(#Bo)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M2299.902 1206.892l175.812 712.215H2124.1z",
    fill: "url(#Bp)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M2180.805 1446.345l175.812 712.214h-351.624z",
    fill: "url(#Bq)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1914.107 1255.25l175.807 712.212H1738.29z",
    fill: "url(#Br)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1623.088 1017.848l175.812 712.21h-351.626z",
    fill: "url(#Bb)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.878 899.146l175.812 712.212h-351.623z",
    fill: "url(#Bc)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.412 863.742l175.814 712.212H869.6z",
    fill: "url(#Bs)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M721.065 764.114l175.812 712.21H545.253z",
    fill: "url(#Be)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M400.093 689.046l175.813 712.212H224.284z",
    fill: "url(#Bt)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M79.944 529.858l175.813 712.214H-95.867z",
    fill: "url(#Bu)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M-41.315 805.72L134.5 1517.933h-351.625z",
    fill: "url(#Bh)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M255.757 863.742l175.813 712.212H79.945z",
    fill: "url(#Bi)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M554.104 852.206l175.814 712.214H378.292z",
    fill: "url(#Bv)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M869.6 966.006l175.81 712.213H693.79z",
    fill: "url(#Bk)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.08 1053.8l175.8 712.21H996.264z",
    fill: "url(#Bl)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.69 1238.92l175.813 712.212H1320.88z",
    fill: "url(#Bw)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1798.9 1338.55l175.812 712.21h-351.624z",
    fill: "url(#Bx)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M2067.254 1487.085L2243.06 2199.3h-351.626z",
    fill: "url(#By)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1648.335 1459.85l175.814 712.21h-351.625z",
    fill: "url(#Bz)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.89 1322.11l175.81 712.214h-351.623z",
    fill: "url(#CA)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.313 1255.25l175.812 712.212H837.502z",
    fill: "url(#CB)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M693.8 1109.944l175.81 712.21H517.976z",
    fill: "url(#CC)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M400.093 1109.944l175.813 712.21H224.284z",
    fill: "url(#Bt)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M109.774 982.443l175.812 712.213H-66.04z",
    fill: "url(#CD)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.678 1206.892l175.812 712.215h-351.626z",
    fill: "url(#CE)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M299.36 1281.26l175.81 712.21H123.547z",
    fill: "url(#CF)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M545.253 1322.11l175.81 712.214H369.44z",
    fill: "url(#CG)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M896.878 1425.562l175.812 712.214H721.064z",
    fill: "url(#CH)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.125 1517.928l175.814 712.216h-351.626z",
    fill: "url(#CI)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1543.09 1637.366l175.814 712.212h-351.625z",
    fill: "url(#CJ)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.888 1766.01l175.814 712.217h-351.626z",
    fill: "url(#CK)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.412 1647.31l175.814 712.213H869.6z",
    fill: "url(#Bs)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M729.917 1530.192l175.812 712.21H554.104z",
    fill: "url(#CL)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M422.46 1575.954l175.814 712.212H246.65z",
    fill: "url(#CM)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M151.134 1425.562l175.81 712.214H-24.678z",
    fill: "url(#CN)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M19.315 1704.457L195.13 2416.67h-351.626z",
    fill: "url(#CO)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M299.36 1724.49l175.81 712.212H123.547z",
    fill: "url(#CF)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M582.225 1781.668l175.81 712.214H406.41z",
    fill: "url(#CP)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M905.73 1900.37l175.812 712.21H729.918z",
    fill: "url(#CQ)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.226 1966.433l175.812 712.207h-351.626z",
    fill: "url(#CR)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.7 2080.596l175.812 712.212H896.88z",
    fill: "url(#CS)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M758.034 1966.433l175.813 712.207H582.224z",
    fill: "url(#CT)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M431.57 1994.503l175.812 712.2H255.756z",
    fill: "url(#CU)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M151.134 1843.2l175.81 712.218H-24.678z",
    fill: "url(#CN)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M19.315 2199.298l175.814 712.2h-351.626z",
    fill: "url(#CO)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M307.52 2242.404l175.812 712.21H131.708z",
    fill: "url(#CV)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M582.225 2299.702l175.81 712.212H406.41z",
    fill: "url(#CP)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M799.25 2350.603l175.814 712.216H623.437z",
    fill: "url(#CW)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M447.624 2482.61l175.814 712.21H271.812z",
    fill: "url(#Bf)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M164.057 2256.477l175.81 712.213H-11.757z",
    fill: "url(#CX)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M32.82 2541.692l175.815 712.21h-351.63z",
    fill: "url(#CY)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2884.183 1940.86l-175.813-712.214-122.99 498.237-153.826-623.142-78.558 318.23-53.093-215.08-39.476 159.915-98.938-400.8-66.676 270.1-53.878-218.258-43.433 175.94-106.06-429.672-73.827 299.075-44.526-180.372-38.264 155-111.735-452.62-90.28 365.725-60.285-244.2-45.405 183.94-106.24-430.37-102.64 415.78-46.168-187.02-45.564 184.583-98.246-397.994-88.59 358.872-70.073-283.87-49.58 200.843L721.065 350.6l-82.268 333.267-62.892-254.77-43.107 174.625-85.172-345.035-108.2 438.326L255.76 358.1 216.92 515.424 123.548 137.17 21.95 548.735l-63.264-256.28-175.81 712.216h126.7l-126.7 513.267h115.665l-99.03 401.17h166.82l-122.826 497.564h122.152l-122.152 494.84h98.024l-84.522 342.392H208.63L138.226 2968.7H327.64l-55.823 226.132H623.44l-45.152-182.908h57.717l-12.566 50.9h351.625l-66.654-270h340.1l-28.183-114.166h176.713l-49.472-200.416H1555.7l-31.76-128.644h194.957l-43.82-177.52h149.067l-29.942-121.3h133.9l-36.66 148.537h351.625l-10.057-40.74h123.615l-59.11-239.45h178.206l-25.464-103.152h113.14l-30.833 124.9z",
    fill: "url(#CZ)",
    style: {
      mixBlendMode: "screen"
    },
    className: "E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Ca)",
    transform: "translate(.002 2930.774)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.74 1752.814l-282.34 1143.747h564.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.282 1552.23l-282.34 1143.748H867.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.982 1331.04l-282.34 1143.744h564.677z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1452.66 1006.82l-282.34 1143.745h564.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1883.6 719.492L1601.264 1863.24h564.676z"
  }))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M2368.922 518.905l-282.34 1143.748h564.672z",
    className: "B"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.833 543.547L2556.494 1687.3h564.68z",
    className: "C"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3332.165 342.768L3049.83 1486.513h564.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3771.286 195.164L3488.95 1338.91h564.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4291.725 0l-282.337 1143.747h564.676z"
  }))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M4079.408 354.8l-282.34 1143.747h564.68z",
    className: "C"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M3565.28 468.83L3282.94 1612.58h564.676z",
    className: "B"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3093.632 663.994l-282.34 1143.748h564.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2607.884 886.265l-282.34 1143.747h564.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2125.395 914.64l-282.34 1143.747h564.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.723 1197.44L1360.386 2341.19h564.677z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1212.58 1414.29L930.24 2558.038h564.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.7 1717.885L514.36 2861.627h564.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.198 1929.313L50.856 3073.057h564.676z"
  }))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M-129.915 2124.102l-282.34 1143.746h564.678z",
    className: "C"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M92.146 2640.92L-190.19 3784.665h564.676z",
    className: "B"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.795 2324.688l-282.34 1143.748h564.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.958 2102.417L705.62 3246.165h564.68z"
  }))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.255 1795.546L1133.92 2939.288h564.676z",
    className: "B"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1883.6 1414.29l-282.337 1143.747h564.676z",
    className: "C"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M2368.922 1223.666l-282.34 1143.747h564.672z",
    className: "B"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M2811.293 1166.81l-282.34 1143.75h564.678z",
    className: "C"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3332.165 1006.82L3049.83 2150.564h564.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3847.618 886.265L3565.28 2030.012h564.676z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4361.747 630.625l-282.34 1143.747h564.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4079.408 1166.81l-282.34 1143.75h564.68z"
  }))), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M3600.29 1148.288l-282.337 1143.747h564.677z",
    className: "B"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3093.632 1331.04l-282.34 1143.744h564.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2607.884 1472.03l-282.34 1143.745h564.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2086.582 1769.317l-282.34 1143.747h564.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1601.265 1929.313l-282.34 1143.744h564.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.317 2167.844L887.98 3311.6h564.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.643 2549.092L454.303 3692.84h564.678z"
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M281.46 2674.29L-.882 3818.038h564.676z",
    className: "B"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520.203 3037.515l-282.34 1143.747h564.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.24 2808.94L647.9 3952.687h564.678z"
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.043 2501.184L1108.7 3644.93h564.672z",
    className: "B"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1843.055 2124.102l-282.34 1143.746h564.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325.545 1902.912l-282.34 1143.747h564.683z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2862.843 1795.546l-282.34 1143.742h564.676z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3375.97 1562.19l-282.34 1143.747h564.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3847.618 1562.19L3565.28 2705.938h564.676z"
  }))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M4313.845 1357.436l-282.34 1143.748h564.678z",
    className: "C"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M4009.388 1837.308l-282.34 1143.747h564.676z",
    className: "B"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M3614.505 1902.912l-282.34 1143.747h564.68z",
    className: "C"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M3049.83 2069.044l-282.34 1143.748h564.677z",
    className: "B"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M2580.504 2217.382l-282.34 1143.75h564.678z",
    className: "C"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2012.072 2409.183l-282.34 1143.747h564.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.717 2615.775L1278.38 3759.522h564.676z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.707 2882.43l-282.34 1143.747h564.676z"
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1747.933 2981.055l-282.34 1143.748h564.68z",
    className: "C"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M2274.157 2615.775l-282.34 1143.747h564.676z",
    className: "B"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2811.293 2425.152L2528.954 3568.9h564.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3317.952 2237.066l-282.34 1143.748h564.678z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3811.696 2310.56L3529.36 3454.306h564.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4247.423 2069.044l-282.338 1143.748h564.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4009.388 2549.092L3727.05 3692.84h564.676z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3555.133 2640.92l-282.34 1143.746h564.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3035.613 2831.54l-282.34 1143.748h564.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2528.953 2937.625l-282.337 1143.748h564.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2767.49 3120.967l-282.343 1143.747h564.682z"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M3272.793 2937.625l-282.336 1143.748h564.67z",
    className: "B"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M3797.068 2982.706L3514.73 4126.453h564.677z",
    className: "C"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M4247.423 2739.718l-282.338 1143.747h564.677z",
    className: "B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4416.767 1774.372h227.317l-155.672-630.625h85.65L4291.724 0l-149.95 607.447-62.368-252.65-134.358 544.278-173.764-703.91-136.78 554.095-69.226-280.432-101 409.14-132.116-535.2L3173.25 986.53l-79.62-322.536-112.533 455.864-142.266-576.312-157.776 639.144-73.176-296.426-74.14 300.34-164.823-667.7-170.608 691.127-72.915-295.4-96.81 392.17L1883.6 719.49l-179.43 726.87-61.447-248.92-71.506 289.665-118.563-480.287-170.334 690.016-69.746-282.544-86.524 350.5-107.074-433.75-158.887 643.648-63.393-256.807-85.264 345.4L585.28 1552.23l-172.587 699.14-79.5-322.062-74.442 301.564-118-478.06-181.157 733.852-89.5-362.564-282.34 1143.747h349.64l-127.577 516.817H7.356l-8.238 33.372h328.407l-89.663 363.224H802.54l-56.425-228.573h98.393l-18.142 73.5h564.676l-65.824-266.656h230.545l-90.172 365.28h564.68l-141.17-571.874h153.713l-51 206.594h334.247l-79.448 321.85h283.793l-45.26 183.342h564.678l-45.26-183.342h521.3l-11.13 45.08h564.68l-59.983-242.986h510.338l-165.558-670.673h165.558l-175.663-711.6h242.083z",
    fill: "url(#Cd)",
    style: {
      mixBlendMode: "screen"
    },
    className: "E"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Ce)",
    transform: "translate(.002 3721.17)",
    fill: "url(#Cf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.757 105.852L-564.68 3429.43h1640.877z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.723 421.187l-820.44 3323.575h1640.878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.15 834.837L698.7 4158.417h1640.878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2205.764 893.586l-820.44 3323.576h1640.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2726.096 1369.996l-820.44 3323.58h1640.878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3158.965 1736.576l-820.44 3323.58h1640.878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.757 1157.2L-564.68 4480.78h1640.877z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.037 1120.337L258.6 4443.915h1640.876z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.24 1431.28l-820.44 3323.578H2678.68z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ch",
    fill: "url(#Cg)",
    style: {
      mixBlendMode: "overlay"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.2a7ac50790e1fa5f571e09f4ef3c2e37.svg";
export { ForwardRef as ReactComponent };